import { ReactNode } from 'react';

import { Outlet } from 'react-router-dom';

import { TrialLoadingSpinner } from './_components/TrialLoadingSpinner';
import { useTrial } from './TrialProvider';

type Props = {
  paywall: ReactNode;
};

/**
 * Route wrapper for trial-gated features.
 *
 * Note: This component uses manual conditional rendering instead of ProtectedRoute
 * because it implements trial-specific state logic (pre-trial, eligibility, trial state)
 * that doesn't map cleanly to CASL ability-based access control.
 */
export const PremiumFeatureRoute = ({ paywall }: Props) => {
  const trial = useTrial();

  if (!trial) {
    return paywall;
  }

  const { isLoading, isEligible, state } = trial;

  if (isLoading) {
    return <TrialLoadingSpinner />;
  }

  if (
    !isEligible || // user is not eligible for trial
    (isEligible && state !== 'pre-trial') // user chose to try out trial
  ) {
    return <Outlet />;
  }

  return paywall;
};
